// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import LogoOrange from 'components/svg/logo/logo-orange.svg'
import LogoGreen from 'components/svg/logo/logo-green.svg'
import LogoPink from 'components/svg/logo/logo-pink.svg'
import PageNavFooter from 'components/PageNavFrame/PageNavFooter'

class Footer extends React.Component {
	render() {
		const { page, isMobileMenu, match } = this.props
		let showPageNavFrame = false

		if ( ! isMobileMenu && page && page.content_type && ! page.is_password_protected && match.params.slug ) {
			if (
				( 'website' == page.content_type || 'branding' == page.content_type || 'graphic_design' == page.content_type )
			) {
				showPageNavFrame = true
			}
		}

		return (
			<footer className="footer">
				{ ( ! isMobileMenu && page && page.show_360south_disclaimer ) &&
					<div className="-disclaimer">
						<p>Disclaimer: This project was undertaken while working at 360South Digital Agency and is the property of <a href="https://www.360south.com.au/" target="_blank" rel="noopener">360South</a>.</p>
					</div>
				}

				{ showPageNavFrame &&
					<PageNavFooter match={ match } />
				}

				<div className="-inner">
					<div className="-content">
						{ ! isMobileMenu &&
							<div className="-logo">
								<Link to="/">
									<div className="-orange">
										<LogoOrange />
									</div>

									<div className="-green">
										<LogoGreen />
									</div>

									<div className="-pink">
										<LogoPink />
									</div>
								</Link>
							</div>
						}

						{ ! isMobileMenu &&
							<h3><a href="/">Merryn Nethercote</a></h3>
						}

						<p>
							<a href="tel:+4407938697958">+44 07938 697958</a><br />
							<a href="mailto:hello@merrynnethercote.com">hello@merrynnethercote.com</a><br />
							<a href="https://au.linkedin.com/in/merryn-nethercote-12199567" target="_blank" rel="noopener">Linked In</a>
						</p>

						<p className="-copy">© Merryn Nethercote { siteData.current_year }</p>
					</div>
				</div>
			</footer>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( Footer )



// WEBPACK FOOTER //
// ./components/Footer/Footer.jsx